import {LocalStoreType, localStore} from 'libs/storage/storage';

/**
 * Retrieves the category list from the local storage.
 *
 * @return {Array<string>} The category list from the local storage. If the category list is not found in the local storage, an empty array is returned.
 */
export const getCategoryListFromLocalStorage = (): LocalStoreType['category_list'] => {
    return localStore.get('category_list') || [];
};
